import moment, { Moment } from 'moment';

export class Common {
    static rubFormatter = Intl.NumberFormat('ru-RU', {
        style: 'currency',
        currency: 'RUB',
    });

    public static FormatDate(date: Date | string | Moment) : string {
        return moment(date).format("DD.MM.YYYY");
    }
    
    public static FormatDateTime(date: Date | string | Moment) : string {
        return moment(date).format("DD.MM.YYYY H:mm");
    }

    public static FormatTimeWSeconds(date: Date | string | Moment) : string {
        return moment(date).format("H:mm:ss");
    }

    public static WeekEarlier(date: string) {
        return this.GetISODate(moment(date).subtract(1, 'week'));
    }

    public static IsWeekend(date: Date | string) : boolean {
        return this.IsWeekendDay(moment(date).isoWeekday());
    }

    public static GetISODate(date: string | Moment) {
        return moment(date).format("YYYY-MM-DD");
    }

    public static IsWeekendDay(day: number) : boolean {
        return day > 5;
    }

    public static FormatMoney(amount: number) {
        return this.rubFormatter.format(amount);
    }

    public static GetColorClassByDiff(diff:number): string {
        if (diff >= 1.1) {
            return 'r-good';
        }
        else if (diff <= 0.9) {
            return 'r-bad'
        }
        else {
            return 'r-normal';
        }
    }

    public static GetOffHourTimeClass(): string {
        return 'r-night';
    }

    public static IsDebugEnvironment(): boolean {
        return window.location.hostname == "localhost";
    }

    public static GetHash(): string {
        if (document.location != null) {
            let hash = document.location.hash;
            if (hash.indexOf("#") == 0) {
                return hash.substr(1);
            } else {
                return hash;
            }
        }
        return "";
    }

    public static GetWeekDaysShort(): string[] {
        return [ 'пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс' ];
    }

    public static GetWeekDaysFull(): string[] {
        return [ "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота", "Воскресенье" ];
    }

    public static isFirefox() {
        return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    }

    public static GetScrollSettings() {
        let speed = 1;

        if (this.isFirefox()) {
            speed = 3.3;
        }

        return { wheelSpeed: speed };
    }

    public static isInt(value: number | string) {
        return !isNaN(Number(value)) && 
                parseInt(value.toString()) == value && 
                !isNaN(parseInt(value.toString(), 10)) &&
                value.toString().indexOf(".") == -1;
    }
}